export default __webpack_public_path__ + "static/heroSectionImg2-3898ff1ab47693ea5e496f828dbe60d9.webp";